import { render, staticRenderFns } from "./CollectionSections.vue?vue&type=template&id=92eaef38&scoped=true&lang=pug&"
import script from "./CollectionSections.vue?vue&type=script&lang=js&"
export * from "./CollectionSections.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSections.vue?vue&type=style&index=0&id=92eaef38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92eaef38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92eaef38')) {
      api.createRecord('92eaef38', component.options)
    } else {
      api.reload('92eaef38', component.options)
    }
    module.hot.accept("./CollectionSections.vue?vue&type=template&id=92eaef38&scoped=true&lang=pug&", function () {
      api.rerender('92eaef38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionSections.vue"
export default component.exports